import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M16.77 10.514a.7.7 0 1 0-.991-.988l-4.526 4.542-2.582-2.591a.7.7 0 1 0-.992.988l3.078 3.089a.7.7 0 0 0 .992 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 9a6 6 0 0 1 6-6h6a6 6 0 0 1 6 6v6a6 6 0 0 1-6 6H9a6 6 0 0 1-6-6zm13.769.524a.7.7 0 0 1 .002.99l-5.022 5.04a.7.7 0 0 1-.992 0l-3.078-3.09a.7.7 0 0 1 .992-.987l2.582 2.591 4.526-4.542a.7.7 0 0 1 .99-.002",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=SuccessFilledIcon24.js.map